import React from 'react';

import Modal from '../../Modal';

const DeleteMembersModal = ({ open, onClose, onConfirmDelete }) => {
  const handleDelete = () => {
    onConfirmDelete();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} sx={{ maxWidth: '852px' }}>
      <div className="modal-delete-additional-member">
        <h2>Are you sure you want to delete the members?</h2>

        <div className="btn-group">
          <button className="btn btn-md btn-outline" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-md btn-primary-ii" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteMembersModal;
